import { Button, ComponentStyle} from '@/imports-files/components/confirmation-modal';

export function ConfirmationModal(props)
{

  let widthClass = props.widthClass ? props.widthClass : '';
  let heightClass = props.heightClass ? props.heightClass : '';
  let buttonwidth = props.buttonwidth ? props.buttonwidth : '';
  let custom_class = props.custom_class ? props.custom_class : '';
  let container_class = props.container_class ? props.container_class : '';

  return(
      <div className = {`CandidateFilterModal ${ComponentStyle.ConfirmationModal}`}>
        <div className={`${ComponentStyle.ConfirmationModal__Inner} ${heightClass} ${widthClass} ${custom_class}`}>
       {props.isCloseRequired && <div className={ComponentStyle.OtpBacksection}>
          <div className={ComponentStyle.Otpback}>
            <Button buttonstyle={ComponentStyle.nobgbutton} type="button" onClick={()=> {props.closeBtnPopup(false)}}>Close</Button>
          </div>
          </div> }
          <div className={`${ComponentStyle.ConfirmationModal__Container} ${container_class}`}>
              <span className={ComponentStyle.ConfirmationModal__Message}>{props.message}</span>
              {props.isMergeAvailable && <div className={ComponentStyle.ConfirmationModal__MergeNotice}>* Close the modal if you wish to accept the candidate as a new application</div>}
              <div className={ComponentStyle.ConfirmationModal__ButtonSection}>
                <Button buttonstyle={ComponentStyle.primarybtn}   onClick={() => {props.closeModal()}}> {props?.texts?.button1_text || 'Cancel'} </Button>
                <Button buttonstyle={`${buttonwidth} ${ComponentStyle.secondarybtn}`} onClick={() => {props.btnAction()}}> {props?.texts?.button2_text || 'Delete'}</Button>
              </div>
          </div>
        </div>
      </div>
    )
} 

